/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import {environment} from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import * as Sentry from "@sentry/angular";

// @ts-ignore
window.CESIUM_BASE_URL = '/assets/cesium/';

Sentry.init({
  dsn: environment.production ? "https://0c54672a12735cca5c7e489ad5ad6e63@o4506753891106816.ingest.us.sentry.io/4507575480025088" : "",
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      autoInject: false,
      triggerLabel: "",
      formTitle: "Feedback",
      submitButtonLabel: "Send",
      messagePlaceholder: ""
    })
  ],
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
